import WarningIcon from "@mui/icons-material/WarningRounded";
import { Tooltip } from "@mui/material";

export const lowConfidenceNote = "Confidence in matching is low. Consider double-checking the input for accuracy.";

const FieldConfidenceWarning = () => {
  return (
    <Tooltip arrow title={lowConfidenceNote}>
      <WarningIcon sx={{ color: "warning.light" }} />
    </Tooltip>
  );
};

export default FieldConfidenceWarning;
